<div class="no-connection-page-content">
  <svg-icon key="no-connection" fontSize="56px" class="m-b-16" />
  <p class="no-connection-title m-b-32">The connection to your data {{ platformName ? 'in ' + platformName : '' }} has not been established yet.</p>

  <!-- visible for Org.Admin and higher -->
  @if (displayNavToSettings) {
    <button class="btn btn-link" (click)="navToSettings()">Edit your settings to establish a connection</button>
  }

  <button class="btn btn-link" (click)="openContactSupportModal()">Contact support</button>
</div>
